import { render, staticRenderFns } from "./GetAllCourses.vue?vue&type=template&id=03b1586a"
import script from "./GetAllCourses.vue?vue&type=script&lang=js"
export * from "./GetAllCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports